import React from 'react';
import './style.css';

const IconStyle = ({ children, ...rest }) => (
  <i className="icon-style" {...rest}>
    {children}
  </i>
);

export default IconStyle;
